import { Fragment } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { BiMenu } from 'react-icons/bi';
import { BsCart } from 'react-icons/bs';
import {
  AiOutlineFileText,
  AiOutlineSolution,
  AiOutlineTeam,
} from 'react-icons/ai';
import { colors, ROLES } from '../constants';
import { PAGE_PATHS } from '../constants';
import { useSelector } from 'react-redux';
import { userSelector } from 'store/selectors';

function NavSide() {
  const location = useLocation();
  const navigate = useNavigate();
  const user = useSelector(userSelector);

  if ([PAGE_PATHS.LOGIN, PAGE_PATHS.SETUP].includes(location.pathname)) {
    return <Fragment />;
  }

  const navigateTo = url => () => {
    navigate(url);
  };

  return (
    <div className="nav-side">
      <div className="header">
        <BiMenu fill={colors.white} />
      </div>
      <div className="menu">
        {user.role !== ROLES.AGENT && (
          <AiOutlineFileText
            fill={
              location.pathname.startsWith(PAGE_PATHS.JOB)
                ? colors.green
                : colors.white
            }
            onClick={navigateTo(PAGE_PATHS.JOB)}
          />
        )}
        {user.role !== ROLES.CLIENT && (
          <BsCart
            fill={
              location.pathname.startsWith(PAGE_PATHS.PRODUCT)
                ? colors.green
                : colors.white
            }
            onClick={navigateTo(PAGE_PATHS.PRODUCT)}
          />
        )}
        {user.role !== ROLES.SPECIALIST &&
          user.role !== ROLES.AGENT &&
          user.role !== ROLES.CLIENT && (
            <AiOutlineTeam
              fill={
                location.pathname.startsWith(PAGE_PATHS.CLIENTS)
                  ? colors.green
                  : colors.white
              }
              onClick={navigateTo(PAGE_PATHS.CLIENTS)}
            />
          )}
        {user.role === ROLES.CLIENT && (
          <AiOutlineSolution
            fill={
              location.pathname.startsWith(PAGE_PATHS.MY_PRODUCT)
                ? colors.green
                : colors.white
            }
            onClick={navigateTo(PAGE_PATHS.MY_PRODUCT)}
          />
        )}
      </div>
    </div>
  );
}

export default NavSide;
